var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"padding":"1em","min-height":"800px","max-height":"800px"}},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" System Dienst Status ")]),_c('v-card-content',[_c('iframe',{attrs:{"src":"https://uptime.marcogriep.de/status/coach2find","width":"100%","height":"720px","frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }